$(function(){
   $('.u_slider_for').slick({
        slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            asNavFor: '.u_slider_nav',
            infinite:false,
            adaptiveHeight: true,
            infinite:false,
            swipe: true,
     prevArrow:'.u_slider_for_larrow',
     nextArrow:'.u_slider_for_rarrow'

      });
      $('.u_slider_nav').slick({
         focusOnSelect: true,
            arrows: false,
            dots: false,
            slidesToScroll: 1,
            slidesToShow: 6,
            cssEase: 'linear',
            lazyLoad: 'ondemand',
            asNavFor: '.u_slider_for',
            infinite:false,
            swipe: true,
        vertical:true,
          responsive: [
    {
      breakpoint: 768,
      settings: {
        vertical:false
      }
    }
  ]
      });
  $(".bls__product-color-swatches").click(function(){
        let val='';
        let final_text = $(this).attr("data-color").toLowerCase().replace(/ /g,'-').trim();
        console.log('data color',final_text);
        let flag = 'false';

        $(".custom-img").each(function(){
          if($(this).attr("data-alt").toLowerCase() == final_text ){
            flag = 'true'
          }
        }); 
        if(flag == 'true'){
          console.log('true')
          $('.u_slider_nav').slick('unslick').empty();
          $(".custom-img").each(function(){
            if($(this).attr("data-alt").toLowerCase() == final_text ){
              $('.u_slider_nav').append($(this).html()); 
            }
          });
      $('.u_slider_nav').slick({
         focusOnSelect: true,
            arrows: false,
            dots: false,
            slidesToScroll: 1,
            slidesToShow: 6,
            cssEase: 'linear',
            lazyLoad: 'ondemand',
            asNavFor: '.u_slider_for',
            infinite:false,
            swipe: true,
        vertical:true,
          responsive: [
    {
      breakpoint: 768,
      settings: {
        vertical:false
      }
    }
  ]
      });
          $('.u_slider_for').slick('unslick').empty(); 
          $(".pro_img").each(function(){
            if($(this).attr("data-alt").toLowerCase() == final_text ){              
              $('.u_slider_for').append($(this).html())
              $('.u_slider_for').find('a').attr('data-fancybox','image')
            }
          });
        $('.u_slider_for').slick({
        slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            asNavFor: '.u_slider_nav',
            infinite:false,
            adaptiveHeight: true,
            infinite:false,
            swipe: true,
     prevArrow:'.u_slider_for_larrow',
     nextArrow:'.u_slider_for_rarrow'

      });
        }
        else{
          console.log('false')
             $('.u_slider_nav').slick('unslick').empty();
           $(".custom-img").each(function(){           
             $('.u_slider_nav').append($(this).html());             
          });
           $('.u_slider_nav').slick({
         focusOnSelect: true,
            arrows: false,
            dots: false,
            slidesToScroll: 1,
            slidesToShow: 6,
            cssEase: 'linear',
            lazyLoad: 'ondemand',
            asNavFor: '.u_slider_for',
            infinite:false,
            swipe: true,
        vertical:true,
          responsive: [
    {
      breakpoint: 768,
      settings: {
        vertical:false
      }
    }
  ]
      });
           $('.u_slider_for').slick('unslick').empty(); 
          $(".pro_img").each(function(){           
              $('.u_slider_for').append($(this).html())
             $('.u_slider_for').find('a').attr('data-fancybox','image')
          });
        $('.u_slider_for').slick({
        slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            asNavFor: '.u_slider_nav',
            infinite:false,
            adaptiveHeight: true,
            infinite:false,
            swipe: true,
     prevArrow:'.u_slider_for_larrow',
     nextArrow:'.u_slider_for_rarrow'

      });
        }
      });
   function fixSlickStyle(event, slick) {
     if (slick.slideCount <= slick.options.slidesToShow) {
      console.log('fire after change')
       $('.u_slider_nav .slick-track').addClass('u_stop_slick_tran')
    }
   }
      $('.u_slider_nav').on('setPosition', function(event, slick, currentSlide){
   fixSlickStyle(event, slick);
  })
  empty_var()
  function empty_var(){
                 $('.u_slider_nav').slick('unslick').empty();
           $(".custom-img").each(function(){           
             $('.u_slider_nav').append($(this).html());             
          });
           $('.u_slider_nav').slick({
         focusOnSelect: true,
            arrows: false,
            dots: false,
            slidesToScroll: 1,
            slidesToShow: 6,
            cssEase: 'linear',
            lazyLoad: 'ondemand',
            asNavFor: '.u_slider_for',
            infinite:false,
            swipe: true,
        vertical:true,
          responsive: [
    {
      breakpoint: 768,
      settings: {
        vertical:false
      }
    }
  ]
      });
           $('.u_slider_for').slick('unslick').empty(); 
          $(".pro_img").each(function(){           
              $('.u_slider_for').append($(this).html())
             $('.u_slider_for').find('a').attr('data-fancybox','image')
          });
        $('.u_slider_for').slick({
        slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            asNavFor: '.u_slider_nav',
            infinite:false,
            adaptiveHeight: true,
            infinite:false,
            swipe: true,
     prevArrow:'.u_slider_for_larrow',
     nextArrow:'.u_slider_for_rarrow'

      });
  }
  $('.bls__product-color-swatches.active').trigger('click')
  
})